import {h, Fragment} from "preact"
import { useAppState } from "@nosto/preact"
import { useEffect } from "preact/hooks";

export default function SearchBanner() {
    const { loading, query, response } = useAppState();
    const docCount = response.products?.total ?? 0;
    
    useEffect(() => {
        if(!loading && query?.query) {
            document.title = `Frye | Search: ${docCount} results found for "${query.query}"`
        }   
    }, [docCount, query, loading])

    return (
        <div class="ns-search-banner">
                <div class="ns-search-banner-eyebrow">Search Results</div>
                {(query?.query) && (
                    <div class="ns-search-banner-heading">
                        We Found {docCount} results for "{query.query}"
                    </div>
                )}
                {(docCount === 0) &&
                    <div class="ns-noresults-text">Double check your spelling or try again with a less specific term.</div>
                }
        </div>
    )
}
